import stripDelimiter from '../../utils/strip-delimiter-from-currency';
import { submitApplicant, submitCoApplicant } from './applicant';

const calculateNewLoan = (
  application,
) => {
  const totalAmount = parseInt(stripDelimiter(application.totalAmount), 10);
  // eslint-disable-next-line
  const currentLoansSum = parseInt(stripDelimiter(application.applicant.currentLoans.totalRefinanceSum), 10);
  let newLoanAmount;

  if (currentLoansSum <= totalAmount) {
    newLoanAmount = totalAmount - currentLoansSum;
  } else {
    newLoanAmount = 0;
  }

  return newLoanAmount;
};

const definePurpose = (
  application,
) => {
  if ((application.merge || application.merge === null)
    && (application.consolidationAmount === application.totalAmount)) {
    return 'consolidateLoans';
  } if (application.purpose !== null && typeof application.purpose !== 'undefined') {
    return application.purpose;
  }
  return 'everydayExpenses';
};

const submit = (application, visibleFields) => ({
  inputSource: application.source,
  totalAmount: String(parseInt(stripDelimiter(application.totalAmount), 10)),
  newLoan: calculateNewLoan(application),
  repaymentTime: String(parseInt(application.repaymentTime, 10) * 12),
  purpose: definePurpose(application),
  acceptNewsletter: application.acceptNewsletter,
  applicant: application.applicant
    ? submitApplicant(application.applicant, visibleFields) : null,
  coApplicant: application.coApplicant
    ? submitCoApplicant(application.coApplicant, visibleFields) : null,
  bankAccount: application.bankAccount,
  creditCheckConsent: application.creditCheckConsent || null,
  acceptAgreement: application.acceptAgreement || null,
  autoAccept: application.autoAccept || false,
});

export default submit;
